import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PowerbiService } from '../../../services/powerbi.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';

@Component({
  selector: 'app-descargas',
  templateUrl: './descargas.component.html',
  styleUrl: './descargas.component.scss',
})
export class DescargasComponent implements OnInit {
  dbId: string | null = null;

  // Define Constructor
  constructor(
    private route: ActivatedRoute,
    private pbiService: PowerbiService,
    private alertaModalService: AlertaModalService
  ) {}

  ngOnInit(): void {
    const dbId = this.route.snapshot.paramMap.get('id');
    this.dbId = dbId ? dbId : this.dbId;
  }

  descargar() {
    if (this.dbId) {
      this.pbiService.downloadFile(this.dbId).subscribe(
        (response: Blob) => {
          const blob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.download = this.dbId + '.xlsx';
          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(anchor);
          if (response) {
            this.alertaModalService.exito(
              '¡Éxito!',
              'El archivo se ha descargado correctamente.'
            );
          }
        },
        error => {
          this.alertaModalService.error('Error al descargar el archivo');
        }
      );
    }
  }
}
